import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { IconPaths } from '_metronic/helpers'
import { RowActions } from 'app/components'
import { EsusEnvioListItem } from '../../../core/_models'
import { podeReenviarStatus, useReenvioEsus } from '../../../core/useReenvioEsus'
import { useQueryResponse } from '../../core/QueryResponseProvider'

type Props = {
  envio: EsusEnvioListItem
}

export const EsusEnvioActionsCell: FC<Props> = ({ envio }) => {
  const navigate = useNavigate()
  const { refetch } = useQueryResponse()
  const { podeReenviar, reenviar } = useReenvioEsus()

  // Reenviar só aparece para quem tem `Esus:resend` e para envio que ainda pode ser transmitido.
  const mostrarReenviar = podeReenviar && podeReenviarStatus(envio.status)

  return (
    <RowActions
      itemName={`envio ${envio.id}`}
      primaryAction={{
        label: 'Detalhe',
        icon: IconPaths.Search,
        onClick: () => navigate(`/apps/esus/detalhes/${envio.id}`),
      }}
      items={[
        { label: 'Reenviar', onClick: () => reenviar(envio.id, refetch), hidden: !mostrarReenviar },
      ]}
    />
  )
}
